import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import LeftNav from "../../common/leftnav";
import GreetingModal from "./greeting_custom/greeting";
import NewClientConfigModal from "./new_client_config/newClientConfig";
import authService from "../../../services/authService";
import { useUser } from "../../../context/UserContext";

const Instructions = () => {
  const { token } = useUser();
  const [loading, setLoading] = useState(true);
  const [dynamicData, setDynamicData] = useState(null);
  const [greetingCustomizationText, setGreetingCustomizationText] = useState(
    "Hello! Thank you for calling. How can I assist you today?"
  );
  const [showGreetingModal, setShowGreetingModal] = useState(false);

  useEffect(() => {
    const fetchDynamicData = async () => {
      if (!token) {
        console.error("No authentication token available");
        return;
      }

      try {
        setLoading(true);
        const data = await authService.getDynamicPrompt(token);
        setDynamicData(data);

        // Set the greeting text if it exists in the response
        if (data.greetings && Array.isArray(data.greetings)) {
          const selectedGreeting = data.greetings.find(
            (greeting) => greeting.selected === true
          );

          if (selectedGreeting?.message) {
            setGreetingCustomizationText(selectedGreeting.message);
          } else {
            console.log("No selected greeting found.");
          }
        } else {
          console.log("Greetings data is not an array or is missing.");
        }
      } catch (error) {
        console.error("Failed to fetch dynamic prompt data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDynamicData();
  }, [token]);

  const handleGreetingModalOpen = () => setShowGreetingModal(true);
  const handleGreetingModalClose = () => setShowGreetingModal(false);

  const handleSaveGreeting = async (newGreeting) => {
    try {
      const greetings = [
        {
          message: newGreeting,
          selected: true,
        },
      ];
      await authService.saveGreetings(greetings, token);
      setGreetingCustomizationText(newGreeting);
      setShowGreetingModal(false);
    } catch (error) {
      console.error("Failed to save greeting:", error);
    }
  };
  const navigate = useNavigate();
  const handleSaveNewClientConfig = (newClientConfig) => {
    console.log("New Client Config Saved:", newClientConfig);
  };

  return (
    <div className="d-flex">
      <LeftNav />
      <Container
        fluid
        className="instructions-content flex-grow-1 p-4 bg-light"
      >
        <Row>
          <Col>
            <h2 className="fs-five-title fw-bold">Agent Settings</h2>
            <p className="gray-color">
              Customize Nouraa to enhance your business call experience.
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="p-4 mt-4 border-0">
              <div>
                <Link
                  to="/agent_settings"
                  className="text-decoration-none purple-color fw-bold mb-4"
                  onClick={() => navigate("/agent_settings")}
                >
                  <img
                    src="../assets/arrow-left.svg"
                    alt="Arrow Right"
                    className="me-1"
                  />
                  Go Back
                </Link>
                <h2 className="fs-two my-4">
                  <img
                    src="../assets/clipboard-blue.svg"
                    alt="Arrow Right"
                    className="me-2"
                  />
                  Instructions
                </h2>
                <p className="gray-color">
                  Customize Nouraa to enhance your business call experience.
                </p>
                <hr className="mb-4 border-dark-subtle" />
              </div>

              <Card.Body className="px-4">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Card.Title className="fs-three mb-0">
                    1. Set Your Greeting
                  </Card.Title>
                </div>
                <div className="d-flex align-items-center w-100 border p-2 rounded-3 mt-4">
                  {/* Quote Icon */}
                  <img
                    src="../assets/teenyicons_quote-solid.svg"
                    alt="Quote Icon"
                    className="me-2 bg-icon p-2"
                  />

                  {/* Textarea */}
                  <p className="mt-3 flex-grow-1">{`"${greetingCustomizationText}"`}</p>

                  {/* Edit Icon (Aligned to Right) */}
                  <img
                    src="/assets/edit-2.svg"
                    alt="Edit Icon"
                    className="ms-2"
                    style={{ cursor: "pointer" }}
                    onClick={handleGreetingModalOpen}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="border-0">
              <Card.Body>
                <NewClientConfigModal
                  onSave={handleSaveNewClientConfig}
                  initialData={dynamicData}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {loading ? (
        <div className="text-center">
          {/* <Spinner animation="border" variant="primary" /> */}
        </div>
      ) : (
        <>
          <GreetingModal
            show={showGreetingModal}
            handleClose={handleGreetingModalClose}
            onSave={handleSaveGreeting}
            greeting={greetingCustomizationText}
          />
        </>
      )}
    </div>
  );
};

export default Instructions;
